import NoTickets from './NoTickets'

export default NoTickets
